import React from 'react';
import DashEstablishmentContainer from 'modules/dashboard/_common/DashEstablishmentContainer';
import CashierSessionPage from 'modules/restaurant/cashier/CashierSessionPage';

export default function DashRestaurantCashierSession() {
    return (
        <DashEstablishmentContainer title='Relatório de Caixa'>
            <CashierSessionPage />
        </DashEstablishmentContainer>
    );
}
